// src/admin/components/CategoryForm.jsx

import { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";

export default function CategoryForm({
    initialValues = {},
    onSubmit,
    saving = false,
}) {

    const { isDark } = useTheme();

    const [formData, setFormData] = useState({
        name: initialValues?.name || "",
        description: initialValues?.description || "",
        is_active: initialValues?.is_active ?? true,
    });

    useEffect(() => {
        setFormData({
            name: initialValues?.name || "",
            description: initialValues?.description || "",
            is_active: initialValues?.is_active ?? true,
        });
    }, [initialValues]);

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        

        onSubmit?.(formData);
    };

    return (

        <form
            onSubmit={handleSubmit}
            className="space-y-6"
        >

            <div>

                <label className="block mb-2 font-medium">
                    Category Name
                </label>

                <input
                    type="text"
                    value={formData.name}
                    onChange={(e) =>
                        handleChange("name", e.target.value)
                    }
                    placeholder="e.g. Web Development"
                    className={inputClass}
                />

            </div>

            <div>

                <label className="block mb-2 font-medium">
                    Description
                </label>

                <textarea
                    rows={5}
                    value={formData.description}
                    onChange={(e) =>
                        handleChange(
                            "description",
                            e.target.value
                        )
                    }
                    placeholder="Short description of this category..."
                    className={inputClass}
                />

            </div>

            <label className="flex items-center gap-3">

                <input
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={(e) =>
                        handleChange(
                            "is_active",
                            e.target.checked
                        )
                    }
                />

                <span>
                    Active Category
                </span>

            </label>

            <button
                type="submit"
                disabled={saving}
                className="
                    w-full
                    rounded-xl
                    bg-blue-500
                    py-3
                    font-semibold
                    text-white
                    transition
                    hover:bg-blue-600
                    disabled:cursor-not-allowed
                    disabled:opacity-60
                "
            >
                {saving ? "Saving..." : "Save Category"}
            </button>

        </form>

    );
}